import { memo } from 'react'

import { FileItem } from '@inno-sdks/files'
import { ZoomControls } from '@inno-ui/zoom-controls'
import { useGetFileItem } from 'modules/desktop/modules/files-integration/api'

import { useItemModal } from '../../../hooks/useItemModal'

export const ImagePreview = memo(() => {
  const { itemId } = useItemModal()
  const { data: item } = useGetFileItem<FileItem>(itemId)

  if (!item?.metaData.presignedUrl) {
    return null
  }

  return <ZoomControls alt={item.name} src={item.metaData.presignedUrl} />
})
